
import Vue from 'vue'
// import staticBlockMixin from '~/mixins/staticBlockMixin';

export default Vue.extend({
  name: 'PunktBlock',
  props: {
    blocks: {
      type: Array,
      default: () => []
    },

    listIconStyle: {
      type: Boolean,
      default: false
    }
  }
})
